<template>
	<div>
		<Header />
		<div class="banners">
			<Banner :src="src" />
		</div>
		<div class="news_data">
			<h2>新闻资讯</h2>
			<ul>
				<li v-for="item in page_list" :key="item.bd_atpid">
					<router-link
						class="clearFloat w1200"
						:to="`/home/news/${item.bd_atpid}`"
					>
						<div class="n_left fl">
							<img :src="item.bd_coverpicturecn" />
						</div>
						<div class="n_center fl">
							<div class="t1">
								<h3>{{ item.bd_titlecn }}</h3>
							</div>
							<div class="t3">
								<p v-html="item.bd_desccn"></p>
							</div>
						</div>
						<div class="n_right fr">
							<span
								>{{ item.bd_atpcreatedatetime
								}}<i>{{ item.bd_atplastmodifydatetime }}</i></span
							>
						</div>
					</router-link>
				</li>
			</ul>

			<el-pagination
				background
				layout="prev, pager, next,jumper"
				:total="new_list.length"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="currentPage"
				:page-size="show_num"
			>
			</el-pagination>
		</div>
		<Footer />
	</div>
</template>
<script>
import Header from '../../components/Header.vue'
import Banner from '../../components/Banner.vue'
import Footer from '../../components/Footer.vue'
const Base64 = require('js-base64')
import Axios from 'axios'
export default {
	components: { Header, Banner, Footer },
	data() {
		return {
			src:'',
			currentPage: 1,
			new_list: [],
			page_list: [],
			show_num: 5,
		}
	},
	created(){
		Axios({
			url: '/apiv2/bdoc/getlist?bdContenttype=新闻',
			data: {},
			method: 'GET',
		}).then((res) => {
			this.new_list=res.data.data.rows
			for (var k = 0; k < this.new_list.length; k++) {
				this.new_list[k].bd_coverpicturecn =
					 this.new_list[k].bd_coverpicturecn
				// this.new_list[k].bd_contentcn = Base64.decode(
				// 	this.new_list[k].bd_contentcn
				// ).slice(3, -8)
				this.new_list[k].bd_atpcreatedatetime = this.new_list[
					k
				].bd_atpcreatedatetime.slice(0, 7)
				this.new_list[k].bd_atplastmodifydatetime = this.new_list[
					k
				].bd_atplastmodifydatetime.slice(8, 10)
				this.new_list[k].id = k
			}
			this.init(1)
		})
	},
	mounted() {
		 Axios({
			url: '/apiv2/sconfig/getlist',
			data: {},
			method: 'GET',
		}).then((res) => {
       let picSrc=res.data.data.rows
		for(var i=0;i<picSrc.length;i++){
			if (picSrc[i].sc_key.slice(0, 13) == 'NEWLISTBANNER') {
					this.src =picSrc[i].sc_value
				}
		};
    })	
		
		
		
	},
	methods: {
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`)
		},
		handleCurrentChange(val) {
			this.init(val)
			 window.scrollTo(0, 300)
		},
		init(val) {
			this.page_list = []
			let index = (val - 1) * this.show_num
			for (var i = index; i < index + this.show_num; i++) {
				// console.log()
				if(this.new_list[i]) this.page_list.push(this.new_list[i]);
			}
		},
	},
}
</script>
<style lang="scss" scoped>
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	.news_data {
		width: 1200px;
		margin: 0 auto;
		.el-pagination {
			text-align: center;
			font-weight: 400;
		}
		h2 {
			font-size: 26px;
			line-height: 100px;
		}
		ul {
			padding-bottom: 50px;
			li {
				border-bottom: 1px solid #a1a1a1;
				padding: 15px 0px 15px;
				height: 150px;
				a {
					display: block;
				}
				.n_left {
					width: 300px;
					height: 145px;
					overflow: hidden;
					float: left;
					img {
						width: 300px;
						height: 145px;
						transition: all 0.4s;
					}
				}
				.n_center {
					width: 700px;
					margin-left: 40px;
					float: left;
					.f1 {
						float: left;
					}
					.t1 h3 {
						font-size: 24px;
						color: #000000;
						font-weight: normal;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
					}
					.t3 p {
						margin-top: 20px;
						font-size: 16px;
						color: #666666;
						line-height: 24px;
						overflow: hidden;
						text-overflow: ellipsis;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 3;
						display: -webkit-box;
					}
				}
				.n_right {
					margin-top: 30px;
					float: left;
					margin-left: 50px;
					span {
						font-size: 20px;
						color: #9b9b9b;
						letter-spacing: 0.27px;
						text-align: center;
						i {
							display: block;
							font-size: 48px;
						}
					}
				}
			}
			li:hover {
				a {
					text-decoration: none;
				}
				.clearFloat .n_center .t1 h3 {
					color: royalblue;
				}
				.clearFloat .n_center .t3 p {
					color: royalblue;
				}
			}
		}
	}
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	::v-deep .el-pagination {
		margin-bottom: rm(20);
	}
	.news_data {
		padding: 0 rm(20);
		.el-pagination {
			text-align: center;
			font-weight: 400;
		}
		h2 {
			font-size: rm(22);
			text-align: center;
			margin-bottom: rm(10);
		}
		ul {
			padding-bottom: rm(50);
			li {
				border-bottom: 1px solid #a1a1a1;
				padding: rm(15) 0px rm(15);
				a {
					display: block;
				}
				.n_left {
					overflow: hidden;

					img {
						width: 100%;
						height: rm(200);
						display: block;
					}
				}
				.n_center {
					.t1 h3 {
						font-size: rm(16);
						color: #000000;
						font-weight: normal;
						margin-top: rm(15);
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
					}
					.t3 p {
						margin-top: rm(20);
						font-size: rm(14);
						color: #666666;
						line-height: rm(24);
						overflow: hidden;
						text-overflow: ellipsis;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 3;
						display: -webkit-box;
					}
				}
				.n_right {
					margin-top: rm(20);
					span {
						font-size: rm(16);
						color: #9b9b9b;
						letter-spacing: rm (0.27);
						text-align: center;
						i {
							font-size: rm(14);
						}
					}
				}
			}
			li:hover {
				a {
					text-decoration: none;
				}
				.clearFloat .n_center .t1 h3 {
					color: royalblue;
				}
				.clearFloat .n_center .t3 p {
					color: royalblue;
				}
			}
		}
	}
}
</style>